import Vue from 'vue';
import Component from 'vue-class-component';
import cart from 'Store/cart/cart';


@Component({})
export default class CartIconComponent extends Vue {

    loading: boolean = true;

    get error(): boolean{
        return cart.state.error;
    }

    get quantity(): number {
        let count = 0;
        if (cart && cart.state.summary) {
            for (let line of cart.state.summary.lines) {
                count += line.quantity;
            }
        }
        return count;
    }

    async created() {
        await cart.dispatchFetchCart();
        this.loading = false;
    }
}
Vue.component('cart-icon', CartIconComponent);